export default __webpack_public_path__ + "static/media/croc_check_line-export2.eb16a180.gif";